import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import {
  getAlgoliaDataHitsResults,
  getAlgoliaDataQueryId,
  getAlgoliaSearchIndice,
} from 'selectors/algolia2/data'
import { getAlgoliaUserToken } from 'selectors/user/cookie'
import { getIsMobileScreenWidth, getScreenIsReady } from 'selectors/screen'
const mapStateToProps = createStructuredSelector({
  algoliaIndice: getAlgoliaSearchIndice,
  algoliaQueryId: getAlgoliaDataQueryId,
  algoliaUserToken: getAlgoliaUserToken,
  artworks: getAlgoliaDataHitsResults,
  isMobileScreen: getIsMobileScreenWidth,
  isScreenReady: getScreenIsReady,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  algoliaIndice: string
  algoliaQueryId: string
  algoliaUserToken: string
  artworks: Array<Record<string, any>>
  isMobileScreen: boolean
  isScreenReady: boolean
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect